/* eslint-disable no-else-return */
import { useEffect, useLayoutEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { loadUser } from "../../store/features/Auth/AuthApi";
import { RootStore, useAppDispatch, useAppSelector } from "../../store/store";
import { Domain } from "../../helpers/utils/DomainSwitcher/domains";
import { ROUTES } from "../../helpers/utils/Constants/route";
import { roles } from "../../helpers/utils/Constants/roles";
import { isSelfPacedStudentWithTAA } from "../../helpers/utils/roleUtils";

const AdminRoute = () => {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(false);
  const [authFail, setAuthFail] = useState(false);
  const dispatch = useAppDispatch();

  const authState: any = useAppSelector((store: RootStore) => {
    return store.AuthSlice;
  });
  const configState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });

  // console.log("adim---");
  useLayoutEffect(() => {
    dispatch(loadUser({ setAuthFail: setAuthFail }));
  }, []);
  useEffect(() => {
    if (authFail) {
      navigate("/");
    }
  }, [authFail]);

  useLayoutEffect(() => {
    if (authState.authenticated && authState.tac_user) {
      if (
        authState.tac_user.role === "user" &&
        configState.configs.membership_enabled === Domain.TAA
      ) {
        navigate(ROUTES.ACADEMIC_USER_DASHBOARD);
      }
            if (
         isSelfPacedStudentWithTAA(authState, configState)
        ) {
          // navigate(ROUTES.SELF_PACED_USER_DASHBOARD);
           navigate(ROUTES.ACADEMIC_USER_DASHBOARD);
          // return
        }
      if (
        authState.tac_user.role === "user" &&
        configState.configs.membership_enabled === Domain.TAC
      ) {
        navigate(ROUTES.PROGRESS);
      }
      if (authState.tac_user.role === "owner") {
        navigate("/organization");
      }
      if (authState.tac_user.role === "admin") {
        navigate("/organization");
      }

      if (authState.tac_user.role === roles.SUB_ADMIN) {
        navigate(ROUTES.DASHBOARD);
      }
      if (authState.tac_user.role === "sys_adm") {
        setAdmin(true);
      }
    }
  }, [authState.authenticated]);

  if (admin) {
    return <Outlet />;
  } else {
    return null;
  }
};

export default AdminRoute;
